import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { flattenRichTextToAppURL } from '../../../helpers/richText';
import { formatDateTimeAsDate } from '../../../helpers/dates';

/** RichText from API or plain HTML string from catalog summary metadata */
const getHtmlDescriptionRaw = (item) => {
  const h = item.html_description;
  if (h == null) return '';
  if (typeof h === 'string') return h;
  if (typeof h === 'object' && h.data !== undefined) return h.data || '';
  return '';
};

const isEffectivelyEmptyRichHtml = (html) => {
  if (!html || typeof html !== 'string') return true;
  const stripped = html
    .replace(/<\/?p[^>]*>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return stripped === '';
};

const FlexNewsCard = memo(({ item, compact, hideLink }) => {
  const htmlDescriptionRaw = getHtmlDescriptionRaw(item);
  const hasHtmlDescription = !isEffectivelyEmptyRichHtml(htmlDescriptionRaw);
  const plainDescription = (item.description || '').trim();

  return (
    <div className="cards__item cards__item--grid">
      {!compact && (
        <CardImage
          item={item}
          fallback={'/news_default_image.png'}
          scalePreference={['large', 'preview']}
          containerClass="cards__image-container--top-news"
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          <h4 className="cards__title">{item.title ? item.title : item.id}</h4>
        ) : (
          <UniversalLink href={item['@id']}>
            <h4 className="cards__title">
              {item.title ? item.title : item.id}
            </h4>
          </UniversalLink>
        )}

        {item.effective && (
          <p className="cards__meta">{formatDateTimeAsDate(item.effective)}</p>
        )}

        {(hasHtmlDescription || plainDescription) &&
          (hasHtmlDescription ? (
            <div
              className="cards__description"
              dangerouslySetInnerHTML={{
                __html: flattenRichTextToAppURL(htmlDescriptionRaw),
              }}
            />
          ) : (
            <p className="cards__description">{plainDescription}</p>
          ))}

        {item.link_field && (
          <div className="cards__action-links">
            <a
              href={item.link_field}
              className="cards__action-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              More info
            </a>
          </div>
        )}
      </div>
    </div>
  );
});

FlexNewsCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    '@type': PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    html_description: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        data: PropTypes.string,
      }),
    ]),
    effective: PropTypes.string,
    link_field: PropTypes.string,
    image_caption: PropTypes.string,
    image_copyright: PropTypes.string,
    image_copyright_black_font: PropTypes.bool,
    image_scales: PropTypes.object,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
};

export default FlexNewsCard;
